import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { NextAuthOptions, Session } from 'next-auth';
import { SearchResponse } from '~/app/[locale]/home/store/requests';
import { authOptions } from '~/app/api/auth/[...nextauth]/constants';
import { AcceptedCookiePolicyType, CookieTypeEnum } from '~/types-and-enums/cookieTypes';
import { DeliveryDetailsType, ShippingAddressType } from '~/types-and-enums/deliveryTypes';
import { InvoiceType } from '~/types-and-enums/invoiceTypes';
import { ReportCaseData } from '~/types-and-enums/reportCasetypes';
import { UserSettingsType } from '~/types-and-enums/settingsTypes';
import { CartDetailsType, ProductType } from '~/types-and-enums/storeTypes';

export const cookieModalAtom = atom<boolean>(false);

export const acceptedCookiePolicyAtom = atomWithStorage<AcceptedCookiePolicyType>(
  'acceptedCookiePolicy',
  CookieTypeEnum.ErrorTracking,
);

export const wantsStoreIsLiveNotification = atom<boolean>(false);

export const openDarkBackgroundAtom = atom<boolean>(false);

export const searchValueAtom = atom<string>('');
export const shippingAddressAtom = atom<ShippingAddressType | null>(null);

// we change it to null to avoid the flickering of the page,it wont cause issues since
// we trigger this in root layout and if some values are not provided we return EMTY_USER_SETTINGS in request
export const userSettingsAtom = atom<UserSettingsType | null>(null);
export const isMobileAtom = atom<boolean>(false);
export const userSessionAtom = atom<Session | NextAuthOptions>(authOptions);

export const loadingCart = atom(false);

export const cartDetailsAtom = atom<CartDetailsType | null>(null);
export const pdpIsOverTotalAvailableQuantitiesAtom = atom<Record<string, boolean>[]>([]);
export const pdpNoAvailablePriceAtom = atom<Record<string, boolean>[]>([]);
export const pdpProductDetailsAtom = atom<ProductType | null>(null);

export const searchResponseAtom = atomWithStorage<SearchResponse | null>('searchResponse', null);

export const similarFEsInDeliveryDetailsPage = atom<DeliveryDetailsType[]>([]);

export type Filters = {
  category?: string;
  priceRange?: [number, number];
  brand?: string;
  deliveryTime?: string;
  page?: number;
};

export const numberOfDisplayedComments = atom<number>(0);

export const reportCaseAtom = atomWithStorage<ReportCaseData>('reportCase', {
  step: {},
  uploadedFileIds: [],
});

export const invoicesAtom = atom<InvoiceType[]>([]);

export type RegistrationFormData = {
  // Step 1
  first_name: string;
  last_name: string;
  email_address: string;
  telephone_number: string;
  // Step 2
  company_name: string;
  vat_id: string;
  business_type:
    | 'Distributor'
    | 'Installer'
    | 'Project Developer'
    | 'Trader'
    | 'EPC'
    | 'Consultancy'
    | 'Investor'
    | 'Planning company'
    | 'Other'
    | '';
  number_of_employees: string;
  street: string;
  city: string;
  country: string;
  postal_code: string;
  annual_revenue_in_net_eur: string;
  annual_purchase_volume_eur: string;
};

export const registrationFormAtom = atom<RegistrationFormData>({
  first_name: '',
  last_name: '',
  email_address: '',
  telephone_number: '',
  company_name: '',
  vat_id: '',
  business_type: '',
  number_of_employees: '',
  street: '',
  city: '',
  country: '',
  postal_code: '',
  annual_revenue_in_net_eur: '',
  annual_purchase_volume_eur: '',
});
